'use client';

import { usePathname } from 'next/navigation';

import { getCookie } from '@/utils/cookies';

import { COOKIE_NAMES } from './constants';
import { BootstrapExperimentsCookie } from './types';

export function getCurrentExperimentByPathname(pathname: string) {
  try {
    const experimentState = getCookie(COOKIE_NAMES.BOOTSTRAP_EXPERIMENTS) as
      | BootstrapExperimentsCookie
      | undefined;

    if (!experimentState) {
      return null;
    }

    const { experimentPaths, featureFlags } = experimentState;
    const flagId = experimentPaths?.[pathname];
    const variant = featureFlags?.[flagId];

    if (!flagId || !variant) {
      return null;
    }

    return {
      flagId,
      variant,
    };
  } catch (error) {
    return null;
  }
}

export function useCurrentExperiment() {
  const pathname = usePathname();

  return getCurrentExperimentByPathname(pathname);
}
